module.exports = __webpack_public_path__ + "img/1.b2df1e63.png";